import { create } from "zustand";

const KRATOS_URL = window._env_.REACT_APP_KRATOS_URL || "http://localhost:4433";

interface SessionIdentity {
    id: string;
    traits: {
        email: string;
    };
}

interface SessionInfo {
    id: string;
    active: boolean;
    identity: SessionIdentity;
}

interface AuthState {
    session: SessionInfo | null;
    loading: boolean;
    checkSession: () => Promise<void>;
    logout: () => Promise<void>;
    clear: () => void;
}

const useAuthStore = create<AuthState>()((set) => ({
    session: null,
    loading: false,

    checkSession: async () => {
        set({ loading: true });
        try {
            const response = await fetch(`${KRATOS_URL}/sessions/whoami`, {
                credentials: "include",
                headers: { Accept: "application/json" },
            });

            if (!response.ok) {
                set({ session: null, loading: false });
                return;
            }

            const data: SessionInfo = await response.json();
            if (data.active) {
                set({ session: data, loading: false });
            } else {
                set({ session: null, loading: false });
            }
        } catch {
            set({ session: null, loading: false });
        }
    },

    logout: async () => {
        try {
            const tokenResponse = await fetch(
                `${KRATOS_URL}/self-service/logout/browser`,
                {
                    credentials: "include",
                    headers: { Accept: "application/json" },
                },
            );

            if (!tokenResponse.ok) {
                throw new Error(`Logout token request failed: ${tokenResponse.status}`);
            }

            const data = await tokenResponse.json();
            if (data.logout_url) {
                window.location.href = data.logout_url;
                return;
            }
        } finally {
            set({ session: null });
        }
    },

    clear: () => {
        set({ session: null, loading: false });
    },
}));

export default useAuthStore;
